<div nz-row>
    <div class="hill-stepper" nz-col [nzSm]="{span: 24}" [nzMd]="{span: 14, offset: 5}" [nzLg]="{span: 10, offset: 7}">
        <form nz-form nzLayout="vertical" [formGroup]="form" class="login-form" (ngSubmit)="onSubmit()">
            <nz-form-item *ngIf="unknownErrorMessages.length > 0">
                <nz-alert nzType="error" *ngFor="let message of unknownErrorMessages" [nzMessage]="message" nzShowIcon>
                </nz-alert>
            </nz-form-item>

            <!-- New Password -->
            <mat-form-field
                id="set-password-new-input"
                appearance="outline"
                class="password-control"
                subscriptSizing="dynamic">
                <mat-label>New Password</mat-label>
                <input
                    [type]="showNewPassword ? 'text' : 'password'"
                    matInput
                    formControlName="newPassword"
                    autocomplete="new-password"
                    required/>
                <mat-icon
                    matSuffix
                    (click)="showNewPassword = !showNewPassword"
                    id="set-password-new-visibility-toggle">
                    <i *ngIf="!showNewPassword" class="fa-solid fa-eye"></i>
                    <i *ngIf="showNewPassword" class="fa-solid fa-eye-slash"></i>
                </mat-icon>
            </mat-form-field>

            <!-- Password Policy Display -->
            <div class="password-policy">
                <ng-container
                    *ngIf="form.get('newPassword')?.dirty && form.get('newPassword')?.invalid"
                    [ngTemplateOutlet]="passwordError"
                    [ngTemplateOutletContext]="{ $implicit: form.get('newPassword') }">
                </ng-container>
                <ng-template #passwordError let-control>
                    <div id="set-password-new-error">
                        <ng-container *ngIf="control.hasError('required')">
                            Please choose your new password.
                        </ng-container>
                        <ng-container *ngIf="control.hasError('minlength')">
                            Your password must be at least 8 characters.
                        </ng-container>
                        <ng-container *ngIf="control.hasError('passwordPolicyFail') && !control.hasError('required')">
                            <div>
                                Password must contain at least 3 of the following 4 types of characters:
                            </div>
                            <div class="password-policy-rule"
                                 [ngClass]="control.getError('passwordPolicyFail').lowerCase ? 'success' : 'fail'">
                <span nz-icon
                      [nzType]="control.getError('passwordPolicyFail').lowerCase ? 'icons/fontawesome/solid:check' : 'icons/fontawesome/solid:times'"></span>
                                Lower case letters (a-z)
                            </div>
                            <div class="password-policy-rule"
                                 [ngClass]="control.getError('passwordPolicyFail').upperCase ? 'success' : 'fail'">
                <span nz-icon
                      [nzType]="control.getError('passwordPolicyFail').upperCase ? 'icons/fontawesome/solid:check' : 'icons/fontawesome/solid:times'"></span>
                                Upper case letters (A-Z)
                            </div>
                            <div class="password-policy-rule"
                                 [ngClass]="control.getError('passwordPolicyFail').numeric ? 'success' : 'fail'">
                <span nz-icon
                      [nzType]="control.getError('passwordPolicyFail').numeric ? 'icons/fontawesome/solid:check' : 'icons/fontawesome/solid:times'"></span>
                                Numbers (0-9)
                            </div>
                            <div class="password-policy-rule"
                                 [ngClass]="control.getError('passwordPolicyFail').specialChar ? 'success' : 'fail'">
                <span nz-icon
                      [nzType]="control.getError('passwordPolicyFail').specialChar ? 'icons/fontawesome/solid:check' : 'icons/fontawesome/solid:times'"></span>
                                Special characters (e.g. !&#64;#$%^&* )
                            </div>
                        </ng-container>
                    </div>
                </ng-template>
            </div>

            <!-- Confirm New Password -->
            <mat-form-field
                id="set-password-confirm-input"
                appearance="outline"
                class="password-control"
                subscriptSizing="dynamic">
                <mat-label>Confirm New Password</mat-label>
                <input
                    [type]="showConfirmPassword ? 'text' : 'password'"
                    matInput
                    formControlName="confirmPassword"
                    autocomplete="new-password"
                    required/>
                <mat-icon
                    matSuffix
                    (click)="showConfirmPassword = !showConfirmPassword"
                    id="set-password-confirm-visibility-toggle">
                    <i *ngIf="!showConfirmPassword" class="fa-solid fa-eye"></i>
                    <i *ngIf="showConfirmPassword" class="fa-solid fa-eye-slash"></i>
                </mat-icon>
                @if (form.get('confirmPassword')?.invalid && form.get('confirmPassword')?.touched) {
                    <mat-error id="set-password-confirm-error">{{ getErrorMessage('confirmPassword') }}</mat-error>
                }
            </mat-form-field>

            <div class="action-buttons">
                 <button
                     id="set-password-submit-button"
                     class="hill-button-secondary submit-button"
                     type="submit"
                     [disabled]="!token || !form.valid || isSettingPassword">
                     <span class="loading-icon" *ngIf="isSettingPassword" nz-icon nzType="loading"
                           nzTheme="outline"></span>
                     Set Password
                 </button>
                 <button *ngIf="showResetRecovery"
                     id="set-password-recovery-button"
                     class="hill-button-secondary-outline"
                     type="button"
                     (click)="onRequestNewLink()">
                     Request a new password reset link
                 </button>
            </div>
        </form>
    </div>
</div>
